import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import {
  LeaderboardRankings,
  RexApiContext,
  ContractDateToUse,
  StatisticsForEntityRequestEntityType,
  StatisticsForEntityRequestTimePeriod,
} from '@urbanx/agx.rex.client';
import dayjs from 'dayjs';

export const useLoadLeaderboardStats = (
  contractDateToUse?: ContractDateToUse,
  fromDate?: string,
  toDate?: string,
  entityType?: StatisticsForEntityRequestEntityType,
  timePeriod?: StatisticsForEntityRequestTimePeriod,
  selectedAgent?: string
): {
  leaderboardStatsResponse: LeaderboardRankings | undefined;
  isPending: boolean;
  isError: boolean;
} => {
  const rexApi = useContext(RexApiContext);

  const convertedFromDate = dayjs(fromDate || '');
  const convertedToDate = dayjs(toDate || '');

  const finalFromDate = convertedFromDate.isValid() ? convertedFromDate.toDate() : undefined;
  const finalToDate = convertedToDate.isValid() ? convertedToDate.toDate() : undefined;

  const {
    data: leaderboardStatsResponse,
    isPending,
    isError,
  } = useQuery<LeaderboardRankings>({
    queryKey: [
      'GetLeaderboardStatisticsForEntity',
      contractDateToUse,
      fromDate,
      toDate,
      entityType,
      timePeriod,
      selectedAgent,
    ],
    queryFn: () =>
      rexApi.getLeaderboardStatisticsForEntity({
        contractDateToUse,
        fromDate: finalFromDate,
        toDate: finalToDate,
        entityType,
        timePeriod,
        selectedAgent,
      }),
    enabled: finalFromDate !== undefined && finalToDate !== undefined,
  });

  return { leaderboardStatsResponse, isPending, isError };
};
